import { 
    Component, ReactNode
} from 'react'

import { BLOG_URL } from '../../confs/costants'

import { UserType } from '../../slices/LoginSlice'

import { loginIcon } from '../../incons/icons'


interface Props {
    updateUserCallBack: Function
    user: UserType | undefined
}

interface Status {
    buttonsLayerIsOpen: boolean
}

class LogoutDropDown extends Component<Props,Status> {

    constructor (props: any) {
        super(props)

        this.state = {
            buttonsLayerIsOpen: false,
        }

        this.toogleLayer = this.toogleLayer.bind( this )

        this.logOut = this.logOut.bind(this)
        this.goToPersonalArea = this.goToPersonalArea.bind(this)
    }

    render(): ReactNode {
        const user = this.props.user

        return (
            (user !== undefined) &&
            <>
                <div
                    id='logout-dropdown-container'
                >
                    {/* stampa il nome e cognome dello user */}
                    <span 
                        className='dropdown-toggle cursor-pointer'
                        onClick={this.toogleLayer}
                    >
                        { loginIcon() } <span>Ciao, {user.name} {user.surname}</span>
                    </span>

                    {/* stampa il layer con i bottoni "area personale / logout" */}
                    { this.state.buttonsLayerIsOpen &&
                        <span
                            className='dropdown-action-select'
                        >
                            <span
                                className='actions'
                            >
                                <button
                                    className='action accedi'
                                    type='button'
                                    onClick={ this.goToPersonalArea }
                                >
                                    Area personale
                                </button>

                                <span className='separator'>
                                    o
                                </span>

                                <button
                                    className='action registrati'
                                    type='button'
                                    onClick={ this.logOut }
                                >
                                    Logout
                                </button>
                            </span>
                        </span>
                    }
                </div>
            </>
        )
    }

    private toogleLayer () {
        let next = {
            buttonsLayerIsOpen: !this.state.buttonsLayerIsOpen
        }

        if (!this.state.buttonsLayerIsOpen)  {
            next = {
                ...next,
                ...{
                    modalLoginIsOpen: false,
                    modalRegisterIsOpen: false,
                }
            }
        }

        this.setState( next )
    }

    private logOut () {
        this.setState({
            buttonsLayerIsOpen: false
        }, () => {
            this.props.updateUserCallBack( undefined )
        })
    }

    private goToPersonalArea () {
        window.location.href = BLOG_URL + 'preventivi/area-personale/' 
    }

}

export default LogoutDropDown